/**
 * Map configuration constants
 * Centralized configuration for Mapbox map initialization and behavior
 */

export const MAP_STYLE = 'mapbox://styles/mapbox/satellite-streets-v12';

// Miami, Florida area
export const INITIAL_CENTER: [number, number] = [-80.19, 25.76];

export const INITIAL_ZOOM = 1.5;

export const SECONDS_PER_REVOLUTION = 120;

export const MAX_SPIN_ZOOM = 3;

export const SLOW_SPIN_ZOOM = 2;
